import type { z } from "zod";

import { Response } from "~/shared/api";

const zRes204 = Response.Schema.zNoBody();
const zRes4xx = Response.Schema.zUnsuccessful2([400, 401, 404]);

const zRes = Response.Schema.zAggregated([zRes204, ...zRes4xx]);
type Res = z.infer<typeof zRes>;

export { zRes };
export type { Res };
